import PostCreateView from "views/Posts/PostCreateView";
import WidgetsView from "../views/Widgets/WidgetsView";
import TreeView from "../views/Tree/TreeView";
import DashBoardView from "../views/DashBoard/DashBoardView";
import SaleView from "views/SaleView/SaleView"
import SalesView from "views/SalesView/SalesView"
import ProjectsView from "views/ProjectsView/ProjectsView"
import WalletView from "views/WalletView/WalletView";
import WalletTransferView from "views/WalletTransferView/WalletTransferView";
import ProfileView from "views/ProfileView/ProfileView";
import DisbursementRequestView from "views/DisbursementRequestView/DisbursementRequestView";
import DisbursementRequestListView from "views/DisbursementRequestListView/DisbursementRequestListView";
import SaleProductUpdateView from "views/SaleProductUpdateView/SaleProductUpdateView";
import SaleNegotiateUpdateView from "views/SaleNegotiateUpdateView/SaleNegotiateUpdateView";
import UnlockRequestView from "views/UnlockRequestView/UnlockRequestView";

var dashboardRoutes = [
    {
        path: "/create-post",
        name: "Crear Post",
        icon: "pe-7s-note2",
        component: PostCreateView,
        needAuth: true
    },
    {
        path: "/widgets",
        name: "Ver WidgetsView",
        icon: "pe-7s-note2",
        component: WidgetsView,
        needAuth: true
    },
    {
        path: "/tree",
        name: "Ver Tree",
        icon: "pe-7s-note2",
        component: TreeView,
        needAuth: true
    },
    {
        path: "/sale",
        name: "Ventas",
        icon: "pe-7s-note2",
        component: SaleView,
        needAuth: true
    },
    {
        path: "/sales",
        name: "Listado de Ventas",
        icon: "pe-7s-note2",
        component: SalesView,
        needAuth: true
    },
    {
        path: "/projects",
        name: "Proyectos",
        icon: "pe-7s-note2",
        component: ProjectsView,
        needAuth: true
    },
    {
        path: "/dashboard",
        name: "Ver dashboard",
        icon: "pe-7s-note2",
        component: DashBoardView,
        needAuth: true
    },
    {
        path: "/profile",
        name: "Ver profile",
        icon: "pe-7s-note2",
        component: ProfileView,
        needAuth: true
    },
    {
        path: "/wallet",
        name: "Cuenta",
        icon: "pe-7s-note2",
        component: WalletView,
        needAuth: true
    },
    {
        path: "/wallet-transfer",
        name: "Transferencia entre Billeteras",
        icon: "pe-7s-note2",
        component: WalletTransferView,
        needAuth: true
    },
    {
        path: "/create-disbursement",
        name: "Solicitud de Desembolso",
        icon: "pe-7s-note2",
        component: DisbursementRequestView,
        needAuth: true
    },
    {
        path: "/create-unlock-request",
        name: "Solicitud para Desbloqueo de Monto Impositivo",
        icon: "pe-7s-note2",
        component: UnlockRequestView,
        needAuth: true
    },
    {
        path: "/disbursements",
        name: "Solicitudes de Desembolso",
        icon: "pe-7s-note2",
        component: DisbursementRequestListView,
        needAuth: true
    },
    {
        path: "/sale-product",
        name: "Actualizar Producto en Afiliación",
        icon: "pe-7s-note2",
        component: SaleProductUpdateView,
        needAuth: true
    },
    {
        path: "/sale-negotiate",
        name: "Actualizar Negociación en Afiliación",
        icon: "pe-7s-note2",
        component: SaleNegotiateUpdateView,
        needAuth: true
    },
    {
        redirect: true,
        path: "/",
        pathTo: "/dashboard",
        name: "dashboard"
    }
];
export default dashboardRoutes;








// WEBPACK FOOTER //
// ./src/routes/dashboardRoutes.jsx